const convertToCSV = (objArray, version) => {
  var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
  var str = "";

  for (var i = 0; i < array.length; i++) {
    var line = "";
    for (var index in array[i]) {
      if (version === undefined) {
        if (line !== "") line += ",";
      } else {
        if (line !== "" && array[i] !== array[0]) line += ",";
      }
      line += array[i][index];
    }

    str += line + "\r\n";
  }

  return str;
};

export const exportCSVFile = (headers, items, fileTitle, version) => {
  if (headers) {
    items.unshift(headers);
    console.log(items);
    if (version) items.unshift(version);
  }
  // Convert Object to JSON
  var jsonObject = JSON.stringify(items);

  var csv = convertToCSV(jsonObject, version);

  var exportedFilename = fileTitle + ".csv" || "export.csv";

  var blob = new Blob(["\ufeff", csv], { type: "text/csv;charset=utf-8;" });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, exportedFilename);
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", exportedFilename);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
